import { render, staticRenderFns } from "./TickerSummary.vue?vue&type=template&id=ee4b7b28&scoped=true"
import script from "./TickerSummary.vue?vue&type=script&lang=js"
export * from "./TickerSummary.vue?vue&type=script&lang=js"
import style0 from "./TickerSummary.vue?vue&type=style&index=0&id=ee4b7b28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee4b7b28",
  null
  
)

export default component.exports